// extracted by mini-css-extract-plugin
module.exports = {"commonCard":"styles_commonCard__17Sgm","commonCardHeader":"styles_commonCardHeader__1-ZJA","commonCardContent":"styles_commonCardContent__3jxVh"};